import Component from "@tunnel-components/@sharded/camera/segmentation/component";
import * as React from "react";
import * as Lodash from "lodash";
import { CheckCameraZoneMaskActionCreator } from "@tunnel-store/index";
import { connect } from "react-redux";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onNextMask
 * @name onChange
 * @name onShowWarningInfos
 * @name onUpdateValue
 * @name onNext
 * @name componentDidUpdate
 * @name render
 * @infos "https://cyclope.ai"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }         state
     * @property { array }          state.active
     * @property { array }          state.checked
     * @property { array }          state.done
     * @property { array }          state.masque
     * @property { array }          state.radio
     * @property { boolean }        state.warning
     */
    this.state = {
      active: [],
      myCameraIsConnected: props.myCameraIsConnected,
      myCameraCode: props.myCameraCode,
      checked: [],
      done: [],
      masque: props.items || [],
      radio: ["auto", "dessiner"],
      checkZoneMask: [],
      warning: false,
      myZoneidentifiant: props.myZoneidentifiant,
    };

    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onNextMask = this.onNextMask.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onRemoveThisMask = this.onRemoveThisMask.bind(this);
    this.onShowWarningInfos = this.onShowWarningInfos.bind(this);
  }
  /**
   * Ouverture / Fermeture
   * @method onShowWarningInfos
   * @param {number}    event
   * @infos "https://reactjs.org"
   */
  public onShowWarningInfos = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ warning: !this.state.warning });
  };
  /**
   * @method onRemoveDraw
   * @param {number}    index
   * @param {number}    param
   * @infos "https://reactjs.org"
   */
  public onRemoveDraw = (index: number, param: number) => (
    event: any
  ): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @name checked
     * @type any[]
     */
    const checked: any[] = this.state.checked;

    checked[index][0] = true;
    checked[index][1] = false;
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      checked,
    });
    this.props.onRemoveDrawPolygon(param);
  };
  /**
   * MAj de l'état du UX
   * @method onChange
   * @param {number} param
   * @param {number} index
   * @param {any}    event
   * @infos "https://reactjs.org"
   */
  public onChange = (index: number, param: number) => (event: any): void => {
    // event.preventDefault();
    /**
     * @constant
     * @name checked
     * @type any[]
     */
    const checked: any[] = this.state.checked;
    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.checked[index].length); i++) {
      checked[index][i] = false;
    }

    checked[index][param] = !this.state.checked[index][param];
    {
      /** Empêcher la mutation du state */
    }
    this.setState(checked);
    this.props.virtualDomUpdate(); // update the dom
    {
      /** comparaison */
    }
    if (param === 1) {
      this.props.onPolygon(index, param);
    } // draw a polygon}
    {
      /** comparaison */
    }
    if (param === 0) {
      this.props.onRemovePolygonCoord(); // supprimer les masques
    }
  };
  /**
   * MAj de l'état du UX
   * @method onUpdateValue
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public onUpdateValue(Elem: any) {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Lodash.isArray(Elem)) {
      /**
       * @constant
       * @name active
       * @type any[]
       */
      const active: any[] = [];

      /**
       * @constant
       * @name done
       * @type any[]
       */
      const checkZoneMask: any[] = [];
      /**
       * @constant
       * @name done
       * @type any[]
       */
      const done: any[] = [];
      /**
       * @constant
       * @name checked
       * @type any[]
       */
      const checked: any[] = [];
      {
        /** boucle */
      }
      for (let i = 0; i < Math.ceil(Elem.length); i++) {
        active.push(false);
        done.push(false);
        checkZoneMask.push(false);
        checked.push([true, false]);
      }
      active[0] = true;
      {
        /** Empêcher la mutation du state */
      }
      this.setState({ active, checked, checkZoneMask, done });
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate = (prevProps: any, prevState: any) => {
    {
      /** comparaison */
    }
    if (prevState.active !== this.state.active) {
      this.props.nextCameraActivated(this.state.active); // activer le prochain caméra
    } else if (prevState.checked !== this.state.checked) {
      for (let i = 0; i < Math.ceil(this.state.masque.length); i++) {
        if (this.state.checked[i][0]) {
          this.props.onRemovePolygonCoord(); // supprimer les masques
        }
      }
    } else if (
      prevProps.myCameraIsConnected !== this.props.myCameraIsConnected
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        myCameraIsConnected: this.props.myCameraIsConnected,
      }));
    } else if (prevProps.myCameraCode !== this.props.myCameraCode) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        myCameraCode: this.props.myCameraCode,
      }));
    } else if (prevProps.checkZone !== this.props.checkZone) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(this.props.checkZone)) {
        this.setState({ checkZoneMasks: !this.props.checkZone });
      }
      {
        /** Comparaison */
      }
    } else if (prevProps.myZoneidentifiant !== this.props.myZoneidentifiant) {
      {
        /** vérification de l'existence de l'élement  */
      }
      this.props.CheckCameraZoneMaskActionCreator(
        this.props.myCameraidentifiant,
        this.props.myZoneidentifiant
      );
      {
        /** Comparaison */
      }
    } else if (prevState.checkZoneMask !== this.state.checkZoneMask) {
      {
        /** vérification de l'existence de l'élement  */
      }
      this.setState((state: any): any => ({
        checkZoneMask: this.state.checkZoneMask,
      }));
      {
        /** Comparaison */
      }
    } else if (prevState.checkZoneMask !== this.state.checkZoneMask) {
      {
        /** vérification de l'existence de l'élement  */
      }

      this.setState((state: any): any => ({
        checkZoneMask: this.state.checkZoneMask,
      }));
      {
        /** Comparaison */
      }
    } else if (prevState.myZoneidentifiant !== this.state.myZoneidentifiant) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        myZoneidentifiant: this.state.myZoneidentifiant,
      }));
    }

    //
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }

    if (nextProps.myCameraIsConnected !== this.props.myCameraIsConnected) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        myCameraIsConnected: nextProps.myCameraIsConnected,
      }));
    } else if (nextProps.myCameraCode !== this.props.myCameraCode) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        myCameraCode: nextProps.myCameraCode,
      }));
    } else if (nextProps.myZoneidentifiant !== this.props.myZoneidentifiant) {
      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({
        myZoneidentifiant: nextProps.myZoneidentifiant,
      }));
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    this.onUpdateValue(this.props.items);
    this.props.virtualDomUpdate();
    // this.props.CheckCameraZoneMaskActionCreator(this.props.myCameraidentifiant, this.state.myZoneidentifiant);
  }
  /**
   * Dessiner le prochain masque
   * @method onNextMask
   * @param { number }  param1
   * @param { number }  param
   * @param { any }     event
   * @infos "https://cyclope.ai"
   */
  public onNextMask = (param: number, param1: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    /**
     * @constant
     * @name active
     * @type any
     */
    const active: any = this.state.active;
    /**
     * @constant
     * @name active
     * @type any
     */
    const checkZoneMask: any = this.state.checkZoneMask;
    /**
     * @constant
     * @name done
     * @type any
     */
    const done: any = this.state.done;

    active[param + 1] = true;
    done[param] = true;
    checkZoneMask[param + 1] = this.state.checkZoneMasks;

    {
      /** Empêcher la mutation du state */
    }
    this.setState({ active, done, checkZoneMask, myZoneidentifiant: param1 });
    this.props.onChangeZone(param1 + 1, this.state.checked[param]);
    this.props.virtualDomUpdate();
    this.props.onRemovePolygonCoord();
  };

  /**
   * Suppression du dessin du masque
   * @method onRemoveThisMask
   * @param { number }  index
   * @param { number }  zone
   * @infos "https://cyclope.ai"
   */
  public onRemoveThisMask = (index: number, zone: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @name checked
     * @type any[]
     */
    const checked: any[] = this.state.checked;
    {
      /** comparaison */
    }
    for (let i = 0; i < Math.ceil(this.state.checked[index].length); i++) {
      checked[index][i] = false;
    }
    checked[index][0] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ checked });
    this.props.onRemovePolygonCoord();
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    this.props.CheckCameraZoneMaskActionCreator(
      this.props.myCameraidentifiant,
      this.state.myZoneidentifiant + 1
    );

    return (
      <Component
        onRemoveThisMask={this.onRemoveThisMask}
        onShowWarningInfos={this.onShowWarningInfos}
        onChange={this.onChange}
        onNextMask={this.onNextMask}
        {...this.state}
        {...this.props}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    checkZone: state.CheckCameraZoneMask.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, { CheckCameraZoneMaskActionCreator })(
  Container
);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/camera/segmentation/container.tsx